import React from 'react';

// containers
import Page from '../../layout/containers/Page/Page';
import StatisticsContainer from '../../containers/StatisticsContainer/StatisticsContainer';

// Constants
import page from './page';

const StatisticsPage = () => {
  return (
    <Page page={page}>
      <StatisticsContainer />
    </Page>
  );
};

export default StatisticsPage;
